export class EditApplicationSync {
  applicationUDFs?: Record<string, string | number | null> = {};
  addressLineOne?: string;
  addressLineTwo?: string;
  addressCity?: string;
  addressState?: string;
  addressZIP?: string;
  latitude?: string;
  longitude?: string;
  jurisdictionId?: string;
  energySourceId?: string;
  energySourceIds?: string[];
  generationTypeId?: string;
  applicationCapacity?: number;
  intentOfGenerationId?: string;
  customerFullName?: string;
  accountNumber?: string;
  projectName?: string;
  businessFriendlyId?: string;
}
